<template>
  <div class="login-container">
    <div class="login-box">
      <h2 class="login-title">预约后台管理系统</h2>
      <el-form ref="loginForm" :model="loginForm" :rules="rules" class="login-form">
        <el-form-item prop="phone">
          <el-input
            v-model="loginForm.phone"
            prefix-icon="el-icon-mobile-phone"
            placeholder="请输入手机号"
            maxlength="11"
            size="large"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            v-model="loginForm.password"
            prefix-icon="el-icon-lock"
            type="password"
            placeholder="请输入密码"
            size="large"
            @keyup.enter.native="handleLogin"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="large" class="login-btn" @click="handleLogin" :loading="loading">
            登 录
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getRoleHome } from '../utils/auth'

export default {
  name: 'Login',
  data() {
    return {
      loginForm: {
        phone: '',
        password: ''
      },
      rules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1\d{10}$/, message: '请输入正确的11位手机号', trigger: 'blur' }
        ],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      loading: false
    }
  },
  methods: {
    handleLogin() {
      this.$refs.loginForm.validate(async valid => {
        if (valid) {
          this.loading = true
          try {
            const res = await this.$http.post('/auth/admin/login', {
              phone: this.loginForm.phone,
              password: this.loginForm.password
            })
            if (res.data.code === 200) {
              const user = res.data.data.user || {}
              localStorage.setItem('token', res.data.data.token)
              localStorage.setItem('user', JSON.stringify(user))
              this.$message.success('登录成功')
              this.$router.push(getRoleHome(user.role))
            } else {
              this.$message.error(res.data.message || '登录失败')
            }
          } catch (e) {
            const msg = (e.response && e.response.data && e.response.data.message)
              || '登录失败，请检查服务器连接'
            this.$message.error(msg)
          } finally {
            this.loading = false
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.login-container {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-box {
  width: 400px;
  padding: 40px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
}

.login-title {
  text-align: center;
  margin-bottom: 30px;
  color: #333;
  font-size: 24px;
  font-weight: 500;
}

.login-form {
  margin-top: 20px;
}

.login-btn {
  width: 100%;
}
</style>
